<template>
    <div>
        <b-card>
            <div class="form-group">

                <div class="row">
                    <div class="col-3">
                        <input class="form-control" v-model="name" placeholder="Назва вiджету">
                    </div>
                    <div class="col-3">
                        <button @click="addWidget" :disabled="isDisabled" class="btn btn-success" style="width:auto; height:auto">
                          <template v-if="isDisabled">
                          <i class="mdi mdi-loading"></i> Створюється...
                          </template>
                          <template v-else>
                          <i class="mdi mdi-check-circle"></i> Додати
                          </template>
                        </button>
                    </div>
                </div>

                <div class="row">
                    <table class="table reader table-books">
                        <thead>
                        <tr>
                            <th class="w-25">
                                Назва
                            </th>
                            <th class="w-25">
                                Дата видачі
                            </th>
                            <th class="w-25">
                                Останнє використання
                            </th>
                            <th class="text-center w-25" >
                                Функції
                            </th>
                        </tr>
                        </thead>
                        <tbody>

                            <tr v-for="item in this.widgets">
                                <td>
                                    {{ item.name }}
                                </td>
                                <td>
                                    {{ moment(item.created_at).format("YYYY-MM-DD hh:mm:ss") }}
                                </td>
                                <td>
                                    {{ (item.last_used_at) ? moment(item.last_used_at).format("YYYY-MM-DD hh:mm:ss") : 'Не використовувався' }}
                                </td>
                                <td class="text-center">
                                    <button @click="deleteWidget(item)" class="btn btn-danger" style="">
                                        <i class="mdi mdi-close-circle"></i> Видалити
                                    </button>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>


<!--                <div v-for="item in this.widgets">-->
<!--                    <div id="accordion">-->
<!--                        <div class="">-->
<!--                            <div class="card-header" id="headingOne">-->
<!--                                <h5 class="mb-0">-->
<!--                                    <button class="btn btn-info" data-toggle="collapse" :data-target="'#collapse-' + item.id"-->
<!--                                            aria-expanded="false" aria-controls="collapseOne">-->
<!--                                        {{ item.name }}-->
<!--                                    </button>-->
<!--                                    <button @click="deleteWidget(item)" class="btn btn-danger" style="">-->
<!--                                        <i class="mdi mdi-close-circle"></i> Видалити-->
<!--                                    </button>-->
<!--                                </h5>-->
<!--                            </div>-->

<!--                            <div :id="'collapse-' + item.id" class="collapse" aria-labelledby="headingOne"-->
<!--                                 data-parent="#accordion">-->
<!--                                <div class="card-body">-->
<!--                                    {{ item.token }}-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->

            </div>

        </b-card>
    </div>
</template>

<script>
    export default {
        name: "Widgets",
        data() {
            return {
                widgets: null,
                name: '',
                isDisabled: false,
            }
        },
        mounted() {
            this.getWidgets();
        },
        methods: {
            getWidgets() {
                axios.get('/library/settings/widgets').then(response => {
                    console.log(response.data);
                    this.widgets = response.data;
                });
            },
            addWidget() {
                this.isDisabled = true;
                axios({
                    url: '/library/settings/widgets',
                    method: 'post',
                    data: { name: this.name },
                }).catch(error => {
                  console.log(error.message);
                  Swal.fire(
                      'Помилка!',
                      error.message,
                      'warning'
                  )
                  this.isDisabled = false;
                }).then(response => {
                    console.log('then');
                    if(response.data.status === 'success'){
                        this.getWidgets();
                        Swal.fire({
                            title: 'Токен створено успішно',
                            html: 'Скопіюйте код для розміщення на сторонньому сайті:' +
                                '<pre>&lt;iframe id=&quot;ebookWidget&quot; src=&quot;'+response.data.url+'&quot; ' +
                                'style=&quot;width:100%;border:0px solid #cccccc;&quot; &gt;&lt;/iframe&gt;<br />' +
                                '&lt;script src=&quot;'+response.data.jsUrl+'&quot;&gt;&lt;/script&gt;<br />' +
                                '&lt;script&gt;iFrameResize({ log: true }, \'#ebookWidget\')&lt;/script&gt;</pre>',
                            type: 'success',
                        })
                    }
                    toastr.success("Збережено");
                    this.isDisabled = false;
                });
            },
            deleteWidget(item){
                Swal.fire({
                    title: 'Ви дійсно хочете видалити віджет?',
                    text: "Обережно, віджет перестане працювати на поточному сайті",
                    // input:'text',
                    // inputValidator:(value) => {
                    //     if(value !== 'ВИДАЛИТИ'){
                    //         return "Для підтвердження напишіть ВИДАЛИТИ"
                    //     }
                    // },
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Так, видалити',
                    cancelButtonText: 'Ні'
                }).then((result) => {
                    if (result.value) {
                        axios({
                            method: 'delete',
                            url: '/library/settings/widgets/' + item.id
                        }).then(response => {
                            if(response.data.status === 'success'){
                                this.getWidgets();
                                Swal.fire(
                                    'Видалено!',
                                    '',
                                    'success'
                                )
                            }else{
                                Swal.fire(
                                    'Не видалено!',
                                    response.data.message,
                                    'warning'
                                )
                            }
                        });

                    }
                })
            },
            moment: function (date) {
                return moment(date);
            },
        },
    }
</script>

<style scoped>

</style>